/** When your routing table is too long, you can split it into small modules **/
import Layout from '../../layout'
import Blank from '../../layout/blank'

export default [
    {
      path: '/content/teacher',
      name: 'content_teacher',
      component: () => import('../../view/teacher/index'),
      meta: { 
        title: '教师管理', 
        icon: 'fe-users', 
        affix: true,
        roles: [
          'content-teacher-view',
        ]
      },
  },
  {
    path: '/content/course',
    name: 'content-course',
    meta: {
      title: '课程管理',
      icon: 'fe-briefcase',
      roles: [
        'content-course-auth-view',
        'content-course-manage-view',
        'content-course-param-view',
      ]
    },
    alwaysShow: true,
    component: Blank,
    children: [
      {
        path: '/content/course/teacher',
        component: () => import('../../view/teacher-course/index'),
        name: 'content-teacher-course',
        meta: { 
          title: '课程授权', 
          icon: 'fe-check-square', 
          affix: true,
          roles: [
            'content-course-auth-view',
          ]
        }
      },
      {
        path: '/content/course/list',
        name: 'content-course-list',
        component: () => import('../../view/course/index'),
        meta: {
          title: '课程库',
          icon: 'dripicons-document-remove',
          roles: [
            'content-course-manage-view',
          ]
        }
      },
      {
        path: '/content/course/param',
        name: 'content-course-param',
        // component: () => import('../../view/course/param'),
        component: () => import('../../view/course-system/index'),
        meta: {
          title: '课程参数',
          icon: 'fe-grid',
          roles: [
            'content-course-param-view',
          ]
        }
      }
    ]
  }   
]
